// extracted by mini-css-extract-plugin
export default {"cv_list_container":"CheckYourCV_cv_list_container__3oaUp","divline_h2_container":"CheckYourCV_divline_h2_container__YzWiI","cards_container":"CheckYourCV_cards_container__SCNSs"};